import { render } from "./TheWattmeter.vue?vue&type=template&id=75ccccc8&scoped=true&scoped=true"
import script from "./TheWattmeter.vue?vue&type=script&scoped=true&lang=js"
export * from "./TheWattmeter.vue?vue&type=script&scoped=true&lang=js"

import "./TheWattmeter.vue?vue&type=style&index=0&id=75ccccc8&scoped=true&lang=css"

import exportComponent from "/home/guilh/Milhagem/Telemetria/dt2-telemetria-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75ccccc8"]])

export default __exports__